import clsx from 'clsx';

export function Tabs({ value, onChange, items }) {
  return (
    <div className="inline-flex items-center rounded-md border border-border-strong bg-surface-elevated p-0.5">
      {items.map((it) => (
        <button
          key={it.value}
          type="button"
          onClick={() => onChange(it.value)}
          className={clsx(
            'rounded px-2.5 py-1 text-xs font-medium transition-colors',
            value === it.value
              ? 'bg-ink text-white'
              : 'text-ink-muted hover:bg-surface-subtle hover:text-ink'
          )}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
